export default __webpack_public_path__ + "img/bg-2.a0ceefd9e41b8778e8e4253bb0e3b4cf.svg";